import {SensorIcon} from '@map/logic';
import {useTranslation} from 'react-i18next';
import {useAvailabilityColors} from '../useAvailabilityColors';

type Props = {
  status: SensorIcon;
};

export const HaNWorkspaceLabel = ({status}: Props) => {
  const {t} = useTranslation();
  const colors = useAvailabilityColors();

  const labels: Record<Exclude<SensorIcon, 'unknown'>, string> = {
    full: t('translation:Full'),
    busy: t('translation:Busy'),
    lively: t('translation:Lively'),
    quiet: t('translation:Quiet'),
  };

  // Unknown status is hidden entirely
  if (status === 'unknown') return null;

  return (
    <div className="flex gap-2 items-center py-0.5 px-1.5 rounded-md border border-mapiq-black-150">
      <span
        className="size-2 rounded"
        style={{backgroundColor: colors[status]}}
      />
      <span className="font-semibold text-[13px] text-mapiq-black-500">{labels[status]}</span>
    </div>
  );
};
